import { PureComponent } from "react";
import { Splitter as KSplitter } from "@progress/kendo-react-layout";

import type {
  SplitterOnChangeEvent as KSplitterOnChangeEvent,
  SplitterPaneProps as KSplitterPaneProps,
  SplitterProps as KSplitterProps,
} from "@progress/kendo-react-layout";

export interface SplitterProps extends KSplitterProps {}
export interface SplitterPaneProps extends KSplitterPaneProps {}
export interface SplitterOnChangeEvent extends KSplitterOnChangeEvent {}

export class Splitter extends PureComponent<KSplitterProps> {
  public static displayName = "Splitter";

  render() {
    const { className, ...otherProps } = this.props;
    return <KSplitter className={`tc-splitter ${className}`} {...otherProps} />;
  }
}
